import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Filter extends Component {
  state = {
    filterText: '',
  };

  handleChange = (e) => {
    const { updateSearch } = this.props;
    e.preventDefault();
    updateSearch(e.target.value);
    this.setState({ filterText: e.target.value });
  };

  render() {
    const { filterText } = this.state;
    const { className, style, placeholder } = this.props;
    return (
      <div className="w-full bg-blue-light text-white font-americaMonoBold text-sm py-2 px-6 rounded my-4 xxl1:my-1 flex justify-between flex-col">
        <span className={`${className} font-americaMonoBold text-xs`}>FILTER CONTENT</span>
        <input className={`rounded py-2 px-4 outline-none ${style || 'my-2'}`} type="text" onChange={this.handleChange} value={filterText} placeholder={placeholder} />
      </div>
    );
  }
}

Filter.propTypes = {
  updateSearch: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.string,
  placeholder: PropTypes.string,
};

Filter.defaultProps = {
  className: '',
  style: '',
  placeholder: '',
};

export default Filter;
